<template lang="pug">
v-container(v-if="report.isLoaded")
  v-layout(align-space-around column)
    v-flex(x12)
      v-card
        v-card-title.headline.font-weight-regular.secondary
          | {{ report.report_schedule.report_theme.title }}
        v-card-text.report__body
          highlight-text(:value="report.body" :queries="highlightQueries")
      .caption.mt-1.text-xs-right
        p {{ report.created_at.toString() }}
    v-flex(v-if="report.commented_at" x12)
      v-card
        v-card-title.font-weight-regular
          | {{ $t("attributes.report.comment") }}
        v-card-text.report__body
          | {{ report.comment }}
      .caption.mt-1.text-xs-right
        p {{ report.commented_at.toString() }}
    v-flex(x12)
      v-layout(align-center column)
        v-btn.mt-3.btn__back(color="primary" @click="onBack")
          | {{ $t('text.back') }}
</template>

<script>
import { plainToClass } from 'class-transformer'
import Report from '@/models/report'
import Response from '@/utils/response'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'
import HighlightText from '@/components/text/HighlightText'

export default {
  components: {
    HighlightText
  },
  mixins: [
    pageLoading,
    pageTitle
  ],
  title () {
    return this.$t("pages.user.reports.show.title")
  },
  props: {
    repository: Object,
    id: Number,
    queryFrom: String
  },
  data: () => ({
    report: new Report()
  }),
  computed: {
    backRoute () {
      if (this.queryFrom) {
        return this.queryFrom
      } else {
        return { name: 'report-index' }
      }
    },
    highlightQueries () {
      return this.report.report_schedule.report_theme.keyword_list
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    report (_) {
      this.$store.commit('setBackRoute', this.backRoute)
    },
  },
  methods: {
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.getById(this.id))
        this.report = plainToClass(Report, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    onBack () {
      this.$router.push(this.backRoute)
    }
  }
}
</script>

<style lang="styl" scoped>
.report__body
  white-space pre-wrap
  font-size 1.2em
.btn__back
  width 120px
</style>
